export const GET_SINGLE_SERVICE = "GET_SINGLE_SERVICE";
export const GET_SINGLE_SERVICE_LOADING = "GET_SINGLE_SERVICE_LOADING";

export const GET_ALL_SERVICES = "GET_ALL_SERVICES";
export const GET_ALL_SERVICES_LOADING = "GET_ALL_SERVICES_LOADING";
